require('./vendors/vendors');

$(() => {

    /*      variables
    /*----------------------------------------*/

    let _window = $(window),
        body = $('body');

    /*      button loading
    /*----------------------------------------*/

    $('[data-loading]').on('click', (e) => {
        e.currentTarget.classList.add('btn-loading');
    });

    /*      select option
    /*----------------------------------------*/

    let select = $('.custom-select-option');

    select.niceSelect();

    select.on('change', (e) => {
        e.target.dispatchEvent(new Event('nice-select-updated', { bubbles: true }));
    });

    /*      overlay
    /*----------------------------------------*/

    let overlay = $('.overlay');

    /*      sidebar cart
    /*----------------------------------------*/

    let headerCart = $('.header-column-right .header-cart'),
        sidebarCart = $('.sidebar-cart-wrap'),
        sidebarCartClose = $('.sidebar-cart-close');

        $('.header-column-right  .text_link_top_nav span').on('click', (e) => {
            window.location.href = $('.header-column-right  .text_link_top_nav a').attr('href');
        });
    headerCart.on('click', (e) => {
        e.stopPropagation();

        let chatBot = $('div#chat-widget-container');
        // if(sidebarCart.hasClass("empty")){
        //     $('.header-cart').css('cursor', 'unset');
        // }
        sidebarCart.toggleClass('active');
    });

    sidebarCartClose.on('click', () => {
        let chatBot = $('div#chat-widget-container');
        overlay.removeClass('active');
        sidebarCart.removeClass('active');
        chatBot.removeClass('move-left');
    });

    sidebarCart.on('click', (e) => {
        e.stopPropagation();
    });

    /*      header
    /*----------------------------------------*/

    let headerWrap = $('.header-wrap'),
        headerWrapInner = $('.header-wrap-inner'),
        headerWrapInnerHeight = headerWrapInner.outerHeight(),
        customerSession = $('.customer-session'),
        headerSearchSm = $('.header-search-sm'),
        searchInputSm = $('.search-input-sm'),
        headerSearchSmClose = $('.header-search-sm-form .btn-close'),
        scrollToTopButton = $('.scroll-to-top');

    headerSearchSm.on('click', (e) => {
        let target = $(e.currentTarget);

        target.parents('.header-search').next().toggleClass('active');
        searchInputSm.focus();
    });

    headerSearchSmClose.on('click', (e) => {
        let target = $(e.currentTarget);

        target.parents('.header-search-sm-form').removeClass('active');
    });

    searchInputSm.on('blur', (e) => {
        let target = $(e.currentTarget);

        // target.parents('.header-search-sm-form').removeClass('active');
    })

    _window.on('resize', () => {
        headerWrapInnerHeight = headerWrapInner.outerHeight();
    });

    _window.on('load scroll resize', () => {
        toggleScrollToTop();
        let topValue = 0
        if( headerWrap.offset())
            topValue= headerWrap.offset().top
        let headerWrapHeight = headerWrap.outerHeight(),
            headerWrapOffsetTop = topValue + headerWrapHeight;


        function stickyHeader() {
            let scrollTop = _window.scrollTop();
            let customerSessionHeight = customerSession.length ? customerSession.outerHeight() : 0;

            if (scrollTop > headerWrapOffsetTop) {
                headerWrap.css('padding-top', `${headerWrapInnerHeight}px`);
                
                if (customerSession.length) {
                    customerSession.addClass('sticky');
                }
                
                headerWrapInner.addClass('sticky');

                setTimeout(() => {
                    if (customerSession.length) {
                        customerSession.addClass('show');
                        headerWrapInner.css('top', `${customerSessionHeight}px`);
                    }
                    headerWrapInner.addClass('show');
                });

                return;
            }

            headerWrap.css('padding-top', 0);
            headerWrapInner.removeClass('sticky show').css('top', '');
            
            if (customerSession.length) {
                customerSession.removeClass('sticky show');
            }
        }


        stickyHeader();
    });

    scrollToTopButton.on('click', (e) => {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 400);
    });

    function toggleScrollToTop() {
        if (!_window.scrollTop()) {
            scrollToTopButton.removeClass('is-visible');
            return;
        }

        scrollToTopButton.addClass('is-visible');
    }

    /*      menu dropdown arrow
    /*----------------------------------------*/

    let megaMenuItem = $('.mega-menu > li'),
        subMenuDropdown = $('.sub-menu > .dropdown'),
        sidebarMenuSubMenu = $('.sidebar-menu .sub-menu');

    function menuDropdownArrow(parentSelector, childSelector) {
        parentSelector.each(function () {
            let self = $(this);

            if (self.children().length > 1) {
                if (window.Trillion.rtl) {
                    self.children(`${childSelector}`).append('<i class="las la-angle-left"></i>');

                    return;
                }

                self.children(`${childSelector}`).append('<i class="las la-angle-right"></i>');
            }
        });
    }

    menuDropdownArrow(subMenuDropdown, 'a');
    menuDropdownArrow(megaMenuItem, '.menu-item');

    /*      navigation
    /*----------------------------------------*/

    let moreCategories = $('.more-categories'),
        categoryDropdown = $('.category-dropdown'),
        categoryNavInner = $('.category-nav-inner'),
        categoryDropdownWrap = $('.category-dropdown-wrap'),
        verticalMegaMenuList = $('.vertical-megamenu > li');

    categoryNavInner.on('click', () => {
        categoryDropdownWrap.toggleClass('show');
    });

    _window.on('load resize', () => {
        let verticalMegaMenuListHeight = 0,
            homeSliderHeight = homeSlider.height(),
            categoryDropdownHeight = homeSliderHeight;

        categoryDropdown.css('height', `${categoryDropdownHeight}px`);

        verticalMegaMenuList.each(function () {
            let self = $(this);

            verticalMegaMenuListHeight += self.height();

            if (verticalMegaMenuListHeight + 78 > categoryDropdownHeight) {
                self.addClass('hide');
                moreCategories.removeClass('hide');

                return;
            }

            self.removeClass('hide');
            moreCategories.addClass('hide');
        });
    });


    /*      mega menu multi level
    /*----------------------------------------*/

    const dropdowns = $('.mega-menu .sub-menu .dropdown');

    dropdowns.each(function () {
        // Get the position of the dropdown relative to the window
        var rect = this.getBoundingClientRect();

        // Check if the dropdown is close to the right edge of the screen
        if (window.innerWidth - rect.right < 300) {
            // Add the class for left-edge positioning
            $(this).addClass('left-edge');
        } else {
            // Add the class for right-edge positioning
            $(this).addClass('right-edge');
        }
    });


    /*      sidebar menu
    /*----------------------------------------*/

    let sidebarMenuIcon = $('.sidebar-menu-icon'),
        sidebarMenuWrap = $('.sidebar-menu-wrap'),
        sidebarMenuClose = $('.sidebar-menu-close'),
        sidebarMenuTab = $('.sidebar-menu-tab a'),
        sidebarMenuList = $('.sidebar-menu li'),
        sidebarMenuLink = $('.sidebar-menu > li > a'),
        sidebarMenuListUl = $('.sidebar-menu > li > ul'),
        sidebarMenuDropdown = $('.sidebar-menu > .dropdown'),
        sidebarMenuSubMenuUl = $('.sidebar-menu .sub-menu ul'),
        sidebarMenuSubMenuLink = $('.sidebar-menu .sub-menu > a');

    sidebarMenuIcon.on('click', (e) => {
        e.stopPropagation();

        overlay.addClass('active');
        sidebarMenuWrap.addClass('active');
    });

    sidebarMenuClose.on('click', (e) => {
        overlay.removeClass('active');
        sidebarMenuWrap.removeClass('active');
    });

    sidebarMenuWrap.on('click', (e) => {
        e.stopPropagation();
    });

    sidebarMenuTab.on('click', (e) => {
        let target = $(e.currentTarget);

        e.preventDefault();
        target.tab('show');
    });

    sidebarMenuList.each(function () {
        let self = $(this);

        if (self.children().length > 1) {
            if (window.Trillion.rtl) {
                self.children('a').after('<i class="las la-angle-left"></i>');

                return;
            }

            self.children('a').after('<i class="las la-angle-right"></i>');
        }
    });

    sidebarMenuDropdown.on('click', (e) => {
        let target = $(e.currentTarget);

        if (! target.hasClass('active')) {
            $('.sidebar-menu > li').removeClass('active');
            target.addClass('active');
        } else {
            $('.sidebar-menu > li').removeClass('active');
        }

        if (! target.children('ul').hasClass('open')) {
            $('.sidebar-menu .open').removeClass('open').slideUp(300);
            target.children('ul').addClass('open').slideDown(300);

            return;
        }

        $('.sidebar-menu .open').removeClass('open').slideUp(300);
    });

    sidebarMenuLink.on('click', (e) => {
        e.stopPropagation();
    });

    sidebarMenuListUl.on('click', (e) => {
        e.stopPropagation();
    });

    sidebarMenuSubMenu.on('click', (e) => {
        let target = $(e.currentTarget);

        if (! target.hasClass('active')) {
            target.addClass('active');
        } else {
            target.removeClass('active');
        }

        target.children('ul').slideToggle(300);
    });

    sidebarMenuSubMenuUl.on('click', function (e) {
        e.stopPropagation();
    });

    sidebarMenuSubMenuLink.on('click', (e) => {
        e.stopPropagation();
    });

    /*      slider
    /*----------------------------------------*/

    let homeSlider = $('.home-slider');

    const addAnimationDuration = () => {
        $('.slider-image.zoomInImage').css('animation-duration', Number(homeSlider.data('autoplay-speed'))/1000 + 's');
    }

    if (homeSlider.length !== 0) {
        homeSlider.slick({
            rows: 0,
            rtl: window.Trillion.rtl,
            cssEase: 'ease',
            speed: Number(homeSlider.data('speed')),
            fade: !! JSON.parse(homeSlider.data('fade')),
            dots: !! JSON.parse(homeSlider.data('dots')),
            arrows: !! JSON.parse(homeSlider.data('arrows')),
            autoplay: !! JSON.parse(homeSlider.data('autoplay')),
            autoplaySpeed: Number(homeSlider.data('autoplay-speed')),
            pauseOnFocus: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        dots: false,
                    },
                },
            ],
        }).slickAnimation().on('afterChange', addAnimationDuration);
    }

    /*      tooltip
    /*----------------------------------------*/

    $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover',
        selector: '[data-toggle="tooltip"]',
    });

    /*      top brands
    /*----------------------------------------*/

    let topBrands = $('.top-brands');

    topBrands.slick({
        rows: 0,
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 7,
        slidesToScroll: 7,
        rtl: window.Trillion.rtl,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6,
                },
            },
            {
                breakpoint: 1050,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                },
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                },
            },
            {
                breakpoint: 750,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
        ],
    });

    /*      sidebar filter
    /*----------------------------------------*/

    let mobileViewFilter = $('.mobile-view-filter');
    let filterSectionWrap = $('.filter-section-wrap');
    let sidebarFilterClose = $('.sidebar-filter-close');

    mobileViewFilter.on('click', (e) => {
        e.stopPropagation();

        filterSectionWrap.addClass('active');
        overlay.addClass('active');
    });

    sidebarFilterClose.on('click', () => {
        filterSectionWrap.removeClass('active');
        overlay.removeClass('active');
    });

    filterSectionWrap.on('click', (e) => {
        e.stopPropagation();
    });

    body.on('click', () => {
        overlay.removeClass('active');
        sidebarCart.removeClass('active');
        sidebarMenuWrap.removeClass('active');
        filterSectionWrap.removeClass('active');
    });

    /*      browse categories
    /*----------------------------------------*/

    $('.browse-categories li').each((i, li) => {
        if ($(li).children('ul').length > 0) {
            $(li).addClass('parent');
        }
    });

    let filterCategoriesLink = $('.browse-categories li.parent > a');
    let parentUls = $('.browse-categories li.active').parentsUntil('.browse-categories', 'ul');

    if (window.Trillion.rtl) {
        filterCategoriesLink.before('<i class="las la-angle-left"></i>');
    } else {
        filterCategoriesLink.before('<i class="las la-angle-right"></i>');
    }

    parentUls.show().siblings('i').addClass('open');

    $('.browse-categories li i').on('click', (e) => {
        $(e.currentTarget).toggleClass('open').siblings('ul').slideToggle(300);
    });

    /*      image gallery
    /*----------------------------------------*/

    let baseImage = $('.base-image');

    $('.additional-image-wrap').slick({
        rows: 0,
        dots: false,
        arrows: true,
        vertical: true,
        infinite: false,
        slidesToShow: 4,
        slideToScroll: 1,
        asNavFor: baseImage,
        focusOnSelect: true,
        adaptiveHeight: true,
        verticalSwiping: true,
        responsive: [
            {
                breakpoint: 577,
                settings: {
                    vertical: false,
                    variableWidth: true,
                    verticalSwiping: false,
                    rtl: window.Trillion.rtl,
                },
            },
        ],
    });

    baseImage.slick({
        rows: 0,
        fade: true,
        dots: false,
        swipe: false,
        arrows: false,
        infinite: false,
        draggable: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        rtl: window.Trillion.rtl,
    });

    baseImage.slickLightbox({
        src: 'data-image',
        itemSelector: '.base-image-slide',
        shouldOpen: function (slick, element, event) {
            return $(event.target).closest('.btn-gallery-trigger').length > 0;
        },
        caption: function (element, info) {
            return document.title.replace(' - Trillion', '');
        },
        slick: {
            fade: true,
            infinite: true,
            rtl: window.Trillion.rtl,
        },
    });

    baseImage.on('show.slickLightbox', function () {
        setTimeout(function () {
            var $lightbox = $('.slick-lightbox');

            // Add custom controls inside each white box
            $lightbox.find('.slick-lightbox-slick-item-inner').each(function () {
                if (!$(this).find('.lightbox-controls').length) {
                    $(this).prepend(
                        '<div class="lightbox-controls">' +
                            '<div class="lightbox-controls-arrows">' +
                                '<button type="button" class="lightbox-ctrl-prev"><i class="las la-angle-left"></i></button>' +
                                '<button type="button" class="lightbox-ctrl-next"><i class="las la-angle-right"></i></button>' +
                            '</div>' +
                            '<button type="button" class="lightbox-ctrl-close"><i class="las la-times"></i></button>' +
                        '</div>'
                    );
                }
            });

            // Wire click handlers
            $lightbox.on('click', '.lightbox-ctrl-close', function (e) {
                e.stopPropagation();
                var closeBtn = $('.slick-lightbox .slick-lightbox-close')[0];
                if (closeBtn) closeBtn.click();
            });

            $lightbox.on('click', '.lightbox-ctrl-prev', function (e) {
                e.stopPropagation();
                $('.slick-lightbox-slick.slick-initialized').slick('slickPrev');
            });

            $lightbox.on('click', '.lightbox-ctrl-next', function (e) {
                e.stopPropagation();
                $('.slick-lightbox-slick.slick-initialized').slick('slickNext');
            });

            // Click on image to go to next
            $lightbox.on('click', '.slick-lightbox-slick-img', function (e) {
                e.stopPropagation();
                $('.slick-lightbox-slick.slick-initialized').slick('slickNext');
            });

            // Prevent closing when clicking the white box area
            $lightbox.on('click', '.slick-lightbox-slick-item-inner', function (e) {
                e.stopPropagation();
            });
        }, 50);
    });

    $('.base-image-slide').zoom({
        magnify: 1.2,
        touch: false,
    });

    /*      number picker
    /*----------------------------------------*/

    $('.btn-number').on('click', function (e) {
        e.preventDefault();

        let $button = $(this);
        let type = $button.attr('data-type');
        let inputGroup = $button.closest('.input-group-quantity');
        let input = inputGroup.find('input.input-quantity');
        let minusButton = inputGroup.find('.btn-number[data-type="minus"]');
        let plusButton = inputGroup.find('.btn-number[data-type="plus"]');
        let minValue = parseInt(input.attr('min')) || 0;
        let maxAttr = input.attr('max');
        let maxValue = maxAttr ? parseInt(maxAttr) : null;
        let currentValue = parseInt(input.val());

        if (! $.isNumeric(currentValue)) {
            currentValue = minValue;
            input.val(currentValue);
            input[0].dispatchEvent(new Event('input', { bubbles: true }));
        }

        if (type === 'minus') {
            if (currentValue > minValue) {
                currentValue -= 1;
                input.val(currentValue);
                input[0].dispatchEvent(new Event('input', { bubbles: true }));
            }

            if (currentValue <= minValue) {
                minusButton.attr('disabled', true);
                currentValue = minValue;
                input.val(currentValue);
            } else {
                minusButton.removeAttr('disabled');
            }

            if (! maxValue || currentValue < maxValue) {
                plusButton.removeAttr('disabled');
            }
        } else if (type === 'plus') {
            if (! maxValue || currentValue < maxValue) {
                currentValue += 1;
                input.val(currentValue);
                input[0].dispatchEvent(new Event('input', { bubbles: true }));
            }

            if (maxValue && currentValue >= maxValue) {
                plusButton.attr('disabled', true);
                currentValue = maxValue;
                input.val(currentValue);
            } else {
                plusButton.removeAttr('disabled');
            }

            if (currentValue > minValue) {
                minusButton.removeAttr('disabled');
            }
        }
    });

    $('.input-number').on('input', function () {
        let self = $(this);
        let inputGroup = self.closest('.input-group-quantity');
        let minusButton = inputGroup.find('.btn-number[data-type="minus"]');
        let plusButton = inputGroup.find('.btn-number[data-type="plus"]');
        let minValue = parseInt(self.attr('min')) || 0;
        let maxAttr = self.attr('max');
        let maxValue = maxAttr ? parseInt(maxAttr) : null;
        let currentValue = parseInt(self.val());
        let isNumericValue = $.isNumeric(self.val());

        if (! isNumericValue) {
            currentValue = minValue;
            self.val(currentValue);
        }

        if (currentValue <= minValue) {
            currentValue = minValue;
            self.val(currentValue);
            minusButton.attr('disabled', true);
        } else {
            minusButton.removeAttr('disabled');
        }

        if (maxValue && currentValue >= maxValue) {
            currentValue = maxValue;
            self.val(currentValue);
            plusButton.attr('disabled', true);
        } else {
            plusButton.removeAttr('disabled');
        }
    });

    /*      My Account Menu
    /*----------------------------------------*/

    $('.account-menu-icon').on('click', () => {
        $('.account-left').toggleClass('show-menu');
    });
});
